<template>
   <!-- 内容区 -->
    <div class="home">
        <!-- banner -->
        <div class="banner-home">
            <div class="container">
                <img src="../assets/images/banner-caption.png">
                <div class="banner-intro">
                    为进一步深入贯彻习近平总书记关于网络强国的重要思想，落实《数据安全法》《个人信息保护法》等法律法规，提升全社会数据安全和个人信息保护意识，河北省委网信办组织开展“保护个人信息 护航数据安全”典型案例征集活动，收集整理河北省各地各单位特别是数据安全从业者保护个人信息、护航数据安全的典型案例......
                </div>
            </div>
        </div>
        <div class="container">
            <div class="d-flex justify-content-between shadow rounded apply-box">
                <div class="card m-3">
                    <img src="../assets/images/icon-class-1.svg" class="card-img-top">
                    <div class="card-body">
                        <h5 class="card-title  text-center">实践类</h5>
                        <p class="card-text">包括但不限于护航数据安全案例、个人信息保护案例、数据跨境解决方案案例。范围包括电子政务、电子商务、人工智能、云计算、大数据...</p>

                    </div>
                    <a :href="filePath1" download="实践类"><span class="iconfont icon-download"></span>下载报名表</a>
                    <router-link :to="{name: 'MyCenter', params: {type: 1}}" class="btn btn-primary btn-round shadow">在线报名&nbsp;<span class="iconfont icon-arrow-right"></span></router-link>
                </div>
                <div class="card m-3">
                    <img src="../assets/images/icon-class-2.svg" class="card-img-top">
                    <div class="card-body">
                        <h5 class="card-title text-center">理论类</h5>
                        <p class="card-text">以征文为主要形式，主题为数据安全保护重要性、个人信息保护重要性、《数据安全法》《个人信息保护法》等法律解读研究或是数据安全治理...</p>
                    </div>
                    <a :href="filePath2"><span class="iconfont icon-download"></span>下载报名表</a>
                    <router-link :to="{name: 'MyCenter', params: {type: 2}}" class="btn btn-primary btn-round shadow">在线报名&nbsp;<span class="iconfont icon-arrow-right"></span></router-link>
                </div>
                <div class="card m-3">
                    <img src="../assets/images/icon-class-3.svg" class="card-img-top">
                    <div class="card-body">
                        <h5 class="card-title text-center">宣传类</h5>
                        <p class="card-text">形式不限，建议以短视频、直播录像、微电影等作品类型为主，主题契合活动，展现贯彻落实《数据安全法》《个人信息保护法》的典型作...</p>

                    </div>
                    <a :href="filePath3"><span class="iconfont icon-download"></span>下载报名表</a>
                    <router-link :to="{name: 'MyCenter', params: {type: 3}}" class="btn btn-primary btn-round shadow">在线报名&nbsp;<span class="iconfont icon-arrow-right"></span></router-link>
                </div>
            </div>
            <div class="news-box">
                <div class="news-title d-flex justify-content-between">
                    <div class="news-title-left"> <img src="../assets/images/title-shape.svg" class="icon-title-shape">活动动态</div>
                    <router-link to="/news" class="more">更多 <img src="../assets/images/title-more.svg"></router-link>
                </div>
                <div class="d-flex row">
                    <router-link class="media shadow m-3" :to="{name: 'NewsDetail', params: {id: item.article_id}}" v-for="item in articleList" :key="item.article_id">
                        <img :src="item.cover" class="mr-3">
                        <div class="media-body">
                            <h5>{{ item.title }}</h5>
                            <p>{{ formatterDate(item.created_at) }}</p>
                            <!-- <p>2021.09.10</p> -->
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { articleList } from "@/network/API.js";
export default {
  data() {
    return {
      articleList: [],
      filePath1: 'https://vote-image.hbzhengwu.com/uploads/ds/%E5%AE%9E%E8%B7%B5%E7%B1%BB%E6%A1%88%E4%BE%8B%E7%94%B3%E6%8A%A5%E4%B9%A6.doc',
      filePath2: "https://vote-image.hbzhengwu.com/uploads/ds/%E7%90%86%E8%AE%BA%E7%B1%BB%E6%A1%88%E4%BE%8B%E7%94%B3%E6%8A%A5%E4%B9%A6.doc",
      filePath3: "https://vote-image.hbzhengwu.com/uploads/ds/%E5%AE%A3%E4%BC%A0%E7%B1%BB%E6%A1%88%E4%BE%8B%E7%94%B3%E6%8A%A5%E4%B9%A6.doc"
    };
  },
  created() {
    articleList({
      page_size: 6,
      page: 1,
      code: "news"
    }).then(res => {
      this.articleList = res.list;
    });
  },
  methods: {
    formatterDate(date) {
      var date = date.split(" ")[0];
      return date.replace(RegExp("-", "g"), ".");
    },
    donwloadFile(type) {
      var filePath = "";
      switch (type) {
        case 1:
          filePath =
            "https://vote-image.hbzhengwu.com/uploads/ds/%E5%AE%9E%E8%B7%B5%E7%B1%BB%E6%A1%88%E4%BE%8B%E7%94%B3%E6%8A%A5%E4%B9%A6.doc";
          break;
        case 2:
          filePath =
            "https://vote-image.hbzhengwu.com/uploads/ds/%E7%90%86%E8%AE%BA%E7%B1%BB%E6%A1%88%E4%BE%8B%E7%94%B3%E6%8A%A5%E4%B9%A6.doc";
          break;
        case 3:
          filePath =
            "https://vote-image.hbzhengwu.com/uploads/ds/%E5%AE%A3%E4%BC%A0%E7%B1%BB%E6%A1%88%E4%BE%8B%E7%94%B3%E6%8A%A5%E4%B9%A6.doc";
          break;
        default:
          filePath = "";
          break;
      }
      let $eleForm = $("<form method='get'></form>");
      $eleForm.attr("action", filePath);
      $(document.body).append($eleForm);
      $eleForm.submit();
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/home.vue